export const HANDBAG_CATEGORIES = [
  'Shoulder',
  'Crossbody',
  'Top Handle',
  'Tote',
  'Mini',
  'Wallet on a Chain',
  'Satchel',
  'Clutch',
  'Backpacks',
  'Belt Bags',
  'Small Leather Goods'
];

// These category strings work for both "FINE" and "DESIGNER" Jewelry categories
export const JEWELRY_CATEGORIES = [
  'Necklaces',
  'Bracelets',
  'Earrings',
  'Rings',
  'Watches'
];
